import { httpClient, IHttpClient } from '@api'
import { TApplicationResponse } from '@api/types'

import { EApplicationType } from '../../stores/types/EApplicationType'
import { EShop } from '../../stores/types/EShop'
import { TApplicationStatusResponse } from '../types/application/TApplicationStatusResponse'
import { TPersonalData } from '../types/TPersonalData'

interface ICommonApplicationClient {
  application(applicationId: string): Promise<TApplicationResponse>
  applicationStatus(applicationId: string): Promise<TApplicationStatusResponse>
  createApplication(
    type: EApplicationType,
    shop: EShop | null,
  ): Promise<TApplicationResponse>
  personalData(userId: string, paymentGatewayId: string): Promise<TPersonalData>
}

const commonApplicationClientFactory = (
  client: IHttpClient,
): ICommonApplicationClient => {
  return {
    application(applicationId: string): Promise<TApplicationResponse> {
      return client.get(`/client/v1/applications/${applicationId}`)
    },
    applicationStatus(
      applicationId: string,
    ): Promise<TApplicationStatusResponse> {
      return client.get(`/client/v1/applications/${applicationId}/status`)
    },
    createApplication(
      type: EApplicationType,
      shop: EShop | null,
    ): Promise<TApplicationResponse> {
      const shopPart = shop ? `?shopCode=${shop}` : ''
      return client.put(`/client/v1/applications/${type}${shopPart}`)
    },
    personalData(
      userId: string,
      paymentGatewayId: string,
    ): Promise<TPersonalData> {
      return client.get(
        `/client/v1/applications/personal-data` +
          `?userId=${userId}` +
          `&paymentGatewayId=${paymentGatewayId}`,
      )
    },
  }
}

export const commonApplicationClient: ICommonApplicationClient =
  commonApplicationClientFactory(httpClient)
